module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_right_red-eae36f89d26f090dc1231a5dbb3c5909.svg";